<p-slider
  [ngModel]="value"
  [min]="minValue()"
  [max]="maxValue()"
  [range]="range()"
  [step]="step()"
  [orientation]="orientation()"
  [styleClass]="sliderClass()"
  (onChange)="onSlideChange($event)"
  [disabled]="readonly || disabled">
</p-slider>
@if (control && control.errors && (control.touched || formGroupDirective?.submitted)) {
  <sxw-error-message [message]="control ? control.errors : null"></sxw-error-message>
}
